import { AxisTickProps } from "./types";

export const AxisTick = ({
  x,
  y,
  dy,
  payload,
  textAnchor,
  fill,
  width,
}: AxisTickProps) => (
  <g transform={`translate(${x},${y})`}>
    <text width={width} x={0} y={0} dy={dy} textAnchor={textAnchor} fill={fill}>
      {payload.value}
    </text>
  </g>
);
